import React from "react";
import PageBanner from "../Common/PageBanner";
import ScrollReveal from "../Common/ScrollReveal";
import "./LeadershipSubPage.css";

const BoardCommittees = () => (
  <div className="leadership-sub-page" style={{ fontFamily: '"Segoe UI", Arial, sans-serif' }}>
    <PageBanner
      title="Board Committees"
      backLabel="Back to Leadership"
      backPath="/leadership"
    />

    <ScrollReveal variant="fadeUp">
    <section className="leadership-sub-content">
        <div className="leadership-sub-inner">
          <h2>Specialized Oversight</h2>
          <p>
            Board Committees support the full Board by focusing on specific areas such as audit, risk, remuneration, and governance. Each committee has defined terms of reference and reports regularly to the Board.
          </p>
          <h3>Committee Overview</h3>
          <ul className="committee-list">
            <li>
              <strong>Audit Committee</strong> — Oversees financial reporting, internal controls, and the internal and external audit process.
            </li>
            <li>
              <strong>Risk Committee</strong> — Monitors risk appetite, risk policies, and key risk indicators across the company.
            </li>
            <li>
              <strong>Remuneration Committee</strong> — Reviews executive compensation, incentives, and alignment with performance and governance standards.
            </li>
            <li>
              <strong>Governance / Nomination Committee</strong> — Supports board composition, director induction, and governance best practices.
            </li>
          </ul>
        </div>
    </section>
    </ScrollReveal>
  </div>
);

export default BoardCommittees;
